export default __webpack_public_path__ + "static/media/labColoringSample.d0ef77dfb72f361f1093f7212297a414.png";